<section class="shiksha-kpi-strip" [attr.aria-label]="content.ariaLabel">
    @for (item of kpiItems(); track item.label) {
        <app-shiksha-kpi-card
            [label]="item.label"
            [value]="item.value"
            [subLabel]="item.subLabel || ''"
            [tooltipText]="item.tooltipText || ''"
            [iconType]="item.iconType"
            [coveragePercent]="item.coveragePercent ?? null"
        ></app-shiksha-kpi-card>
    }
</section>
